<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('update requests')"
      :columns="columns"
      :column_search="false"
      resource_url="/account-request/request/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>

    <!-- Modal para crear/editar -->
    <request-modal ref="request_modal" @success="refresh_datatable" />
    <view-modal ref="view_modal" @success="refresh_datatable" />
    <log-modal ref="log_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import RequestModal from "./request_modal/Index.vue";
import LogModal from "./log_modal/Index.vue";
import ViewModal from "./view_modal/Index.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  post,
  format_date_time,
  error_message,
} from "@/utils";

export default {
  name: "AccountRequestDataTable",
  components: {
    GenericTable,
    RequestModal,
    LogModal,
    ViewModal,
  },
  data() {
    return {
      columns: [
        {
          title: this.$t("client dpi"),
          name: "client_dpi",
          searchable: true,
          width: "15%",
          data: (row) => row.client_dpi || "",
        },
        {
          title: this.$t("client email"),
          name: "client_email",
          searchable: true,
          width: "25%",
          data: (row) => row.client_email || "",
        },
        {
          title: this.$t("client phone"),
          name: "client_phone",
          searchable: true,
          width: "15%",
          data: (row) => row.client_phone || "-",
        },
        {
          title: this.$t("status"),
          name: "status",
          width: "10%",
          data: (row) => {
            const status = row.status;
            const statusClass =
              status === "completed" ? "is-success" : "is-warning";
            const statusText = this.$t(status);
            return `<span class="tag ${statusClass}">${statusText}</span>`;
          },
        },
        {
          title: this.$t("created"),
          name: "create_date",
          width: "15%",
          data: (row) => format_date_time(row.create_date),
        },
        {
          title: this.$t("actions"),
          width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("view request"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  this.view(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("renap"),
                icon: "fa fa-bolt",
                icon_class: "is-small",
                click: (e) => {
                  this.renap(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("view as customer"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-warning",
                click: (e) => {
                  window.open(
                    `/account-request/complete/${row.uuid}`,
                    "_blank"
                  );
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("log"),
                icon: "fa fa-list",
                icon_class: "is-small",
                click: (e) => {
                  this.log(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  this.delete(row);
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      this.$refs.request_modal.show_modal();
    },
    edit(row) {
      this.$refs.request_modal.show_modal(row.uuid);
    },
    delete(row) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete request?"),
        v,
        () => {
          del("/account-request/request", { uuid: row.uuid })
            .then(() => {
              v.refresh_datatable();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    renap(row) {
      let v = this;
      post("/account-request/request/renap", { uuid: row.uuid })
        .then(() => {
          v.refresh_datatable();
        })
        .catch((error) => {
          error_message(error);
        });
    },
    refresh_datatable() {
      this.$refs.datatable.refresh();
    },
    log(row) {
      let v = this;
      v.$refs.log_modal.show(row.uuid);
    },
    view(row) {
      let v = this;
      v.$refs.view_modal.show(row.uuid);
    },
  },
  mounted() {
    this.refresh_datatable();
  },
};
</script>
